import { useState } from 'react';
import { useFormContext, type FieldValues } from 'react-hook-form';

export interface AttachmentFieldProps {
  name: string;
  required?: boolean;
  onUpload: (file: File) => Promise<{ attachment_id: string }>;
}

export function AttachmentField({ name, required, onUpload }: AttachmentFieldProps) {
  const { setValue, register } = useFormContext<FieldValues>();
  const [meta, setMeta] = useState<{ name: string; size: number } | null>(null);
  const [error, setError] = useState<string | null>(null);

  register(name, { required });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(null);
    const file = e.target.files?.[0];
    if (!file) {
      setValue(name, undefined, { shouldValidate: true });
      setMeta(null);
      return;
    }
    onUpload(file)
      .then((res) => {
        setValue(name, { attachment_id: res.attachment_id }, { shouldValidate: true });
        setMeta({ name: file.name, size: file.size });
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : 'Upload failed');
        setValue(name, undefined, { shouldValidate: true });
        setMeta(null);
      });
  };

  return (
    <label>
      <span>
        {name}
        {required ? ' *' : ''}
      </span>
      <input type="file" aria-label={name} onChange={handleChange} />
      {meta ? (
        <small>
          {meta.name} ({meta.size} bytes)
        </small>
      ) : null}
      {error ? <small style={{ color: 'crimson' }}>{error}</small> : null}
    </label>
  );
}
